export default __webpack_public_path__ + "static/media/question.f08ca9ea.svg";